const MinimalTest = () => {
  return (
    <div>
      <h1>Minimal Test Page</h1>
      <p>This is working!</p>
    </div>
  );
};

export default MinimalTest;
